"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecordingText = exports.AdditionalRoomState = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _usePlaylistMusic = require("../hooks/usePlaylistMusic");
var _useScreenshareAudio = require("../hooks/useScreenshareAudio");
var _useWhiteboardMetadata = require("../../plugins/whiteboard/useWhiteboardMetadata");
var _constants = require("../../common/constants");
var _useUISettings = require("../AppData/useUISettings");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getRecordingText = function getRecordingText(_ref) {
  var isBrowserRecordingOn = _ref.isBrowserRecordingOn,
    isServerRecordingOn = _ref.isServerRecordingOn,
    isHLSRecordingOn = _ref.isHLSRecordingOn;
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ", ";
  if (!isBrowserRecordingOn && !isServerRecordingOn && !isHLSRecordingOn) {
    return "";
  }
  var title = [];
  if (isBrowserRecordingOn) {
    title.push("Browser");
  }
  if (isServerRecordingOn) {
    title.push("Server");
  }
  if (isHLSRecordingOn) {
    title.push("HLS");
  }
  return title.join(delimiter);
};

/**
 * Display state of recording, streaming, playlist, whiteboard
 */
exports.getRecordingText = getRecordingText;
var AdditionalRoomState = function AdditionalRoomState() {
  var _playlist$peer, _playlist$track, _playlist$peer2, _screenshareAudio$pee, _screenshareAudio$tra;
  var playlist = (0, _usePlaylistMusic.usePlaylistMusic)();
  var isAudioOnly = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.isAudioOnly);
  var screenshareAudio = (0, _useScreenshareAudio.useScreenshareAudio)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var isPlaylistInactive = [!playlist.peer || !playlist.track, !((_playlist$peer = playlist.peer) !== null && _playlist$peer !== void 0 && _playlist$peer.isLocal) && !((_playlist$track = playlist.track) !== null && _playlist$track !== void 0 && _playlist$track.enabled), ((_playlist$peer2 = playlist.peer) === null || _playlist$peer2 === void 0 ? void 0 : _playlist$peer2.isLocal) && !playlist.selection].some(Boolean);
  var isAudioshareInactive = [!screenshareAudio.peer || !screenshareAudio.track, !((_screenshareAudio$pee = screenshareAudio.peer) !== null && _screenshareAudio$pee !== void 0 && _screenshareAudio$pee.isLocal) && !((_screenshareAudio$tra = screenshareAudio.track) !== null && _screenshareAudio$tra !== void 0 && _screenshareAudio$tra.enabled)].some(Boolean);
  var peerSharingPlaylist = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingVideoPlaylist);
  var localPeerID = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var isVideoPlayListPlaying = !!(peerSharingPlaylist !== null && peerSharingPlaylist !== void 0 && peerSharingPlaylist.id);
  var _useScreenShare = (0, _reactSdk.useScreenShare)(),
    screenSharingPeerName = _useScreenShare.screenSharingPeerName,
    screenSharingPeerId = _useScreenShare.screenSharingPeerId,
    screenShareVideoTrackId = _useScreenShare.screenShareVideoTrackId;
  var isVideoScreenSharingOn = !!screenShareVideoTrackId;
  var _useWhiteboardMetadat = (0, _useWhiteboardMetadata.useWhiteboardMetadata)(),
    whiteboardOwner = _useWhiteboardMetadat.whiteboardOwner,
    amIWhiteboardOwner = _useWhiteboardMetadat.amIWhiteboardOwner,
    toggleWhiteboard = _useWhiteboardMetadat.toggleWhiteboard;
  var shouldShowScreenShareState = isAudioOnly && isVideoScreenSharingOn;
  var shouldShowVideoState = isAudioOnly && isVideoPlayListPlaying;
  if (isPlaylistInactive && isAudioshareInactive && !shouldShowScreenShareState && !shouldShowVideoState && !whiteboardOwner) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
    open: open,
    onOpenChange: setOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        css: {
          color: "$textPrimary",
          borderRadius: "$1",
          border: "1px solid $textDisabled",
          padding: "$4",
          "@sm": {
            display: "none"
          }
        },
        "data-testid": "record_status_dropdown",
        children: [!isAudioshareInactive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "Screenshare Audio",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
            align: "center",
            css: {
              color: "$textPrimary",
              mx: "$2"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MusicIcon, {
              width: 24,
              height: 24
            })
          })
        }), shouldShowScreenShareState && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "Screenshare",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
            align: "center",
            css: {
              color: "$textPrimary",
              mx: "$2"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ShareScreenIcon, {
              width: 24,
              height: 24
            })
          })
        }), shouldShowVideoState && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "video playlist",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
            align: "center",
            css: {
              color: "$textPrimary",
              mx: "$2"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VideoPlayerIcon, {
              width: 24,
              height: 24
            })
          })
        }), !isPlaylistInactive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "Playlist Music",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
            align: "center",
            css: {
              color: "$textPrimary",
              mx: "$2"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.AudioPlayerIcon, {
              width: 24,
              height: 24
            })
          })
        }), whiteboardOwner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "Whiteboard",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
            align: "center",
            css: {
              color: "$textPrimary",
              mx: "$2"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PencilDrawIcon, {
              width: 24,
              height: 24
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
          css: {
            "@lg": {
              display: "none"
            },
            color: "$textDisabled"
          },
          children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronUpIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {})
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
      sideOffset: 5,
      align: "end",
      css: {
        w: "$60"
      },
      children: [!isPlaylistInactive && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        css: {
          color: "$textPrimary"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.AudioPlayerIcon, {
          width: 24,
          height: 24
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$2",
            flex: "1 1 0"
          },
          children: "Playlist is playing"
        }), playlist.peer.isLocal ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            color: "$error",
            cursor: "pointer",
            ml: "$2"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            playlist.selection.playing ? playlist.pause() : playlist.play(playlist.selection.id);
          },
          children: playlist.selection.playing ? "Pause" : "Play"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            color: "$error",
            ml: "$2",
            cursor: "pointer"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            playlist.setVolume(!playlist.track.volume ? 100 : 0);
          },
          children: playlist.track.volume === 0 ? "Unmute" : "Mute"
        })]
      }), !isAudioshareInactive && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        css: {
          color: "$textPrimary"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MusicIcon, {
          width: 24,
          height: 24
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$2",
            flex: "1 1 0"
          },
          children: "Music is playing"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            color: "$error",
            ml: "$2",
            cursor: "pointer"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            screenshareAudio.onToggle();
          },
          children: screenshareAudio.muted ? "Unmute" : "Mute"
        })]
      }), shouldShowScreenShareState && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        css: {
          color: "$textPrimary"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ShareScreenIcon, {
          width: 24,
          height: 24
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$2",
            flex: "1 1 0"
          },
          children: "Shared by: ".concat(screenSharingPeerId === localPeerID ? "You" : screenSharingPeerName)
        })]
      }), shouldShowVideoState && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        css: {
          color: "$textPrimary"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VideoPlayerIcon, {
          width: 24,
          height: 24
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$2",
            flex: "1 1 0"
          },
          children: "Shared by: ".concat(peerSharingPlaylist.id === localPeerID ? "You" : peerSharingPlaylist.name)
        })]
      }), whiteboardOwner && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        css: {
          color: "$textPrimary"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PencilDrawIcon, {
          width: 24,
          height: 24
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$2",
            flex: "1 1 0"
          },
          children: ["Whiteboard Owner - ", whiteboardOwner.name, amIWhiteboardOwner && "(You)"]
        }), amIWhiteboardOwner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            color: "$error",
            ml: "$2",
            cursor: "pointer"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            toggleWhiteboard();
          },
          children: "Stop"
        })]
      })]
    })]
  });
};
exports.AdditionalRoomState = AdditionalRoomState;